// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

export const options = {
  // You can set your default options here
  timeout: 2000
};

